import { Modal } from "react-bootstrap";
import { X, InfoSquare, Whatsapp, Globe2 } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import logo from "../content/images/logo.png";
const pkg = require('../../package.json');

const ModalAboutUs = (props) => {
    let appVersion = useSelector(state => state.SystemSettingsReducer.currentVersion);
    if (appVersion && appVersion != '') {
        appVersion = appVersion.filter(a => a.indexOf("سریال") < 0);
    }
    return (
        <Modal show={props.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#838fe8' }}><span><InfoSquare color="white" size={20} />&nbsp;درباره بی همتا</span><span onClick={() => props.setModalAboutUs(false)} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body style={{ textAlign: "center" }}>
                <img src={logo} alt='' />
                <p style={{ color: "blue", margin: "3px", fontSize: "12px" }}>نسخه نرم افزار: {pkg.version}</p>
                {appVersion && appVersion.map((item, i) => <p style={{ color: "blue", margin: "3px", fontSize: "12px" }} key={i}>{item}</p>)}
                <a style={{ fontStyle: "italic", fontSize: "14px" }} href="https://Bihamta.biz">www.Bihamta.biz <Globe2 /></a>
                <p style={{ color: "black", fontStyle: "italic" }}><span style={{ color: "#227b80" }}>09213979624</span> <Whatsapp color="green" /></p>
            </Modal.Body>
            <Modal.Footer style={{ direction: "ltr" }}>
            </Modal.Footer>
        </Modal>
    )
}
export default ModalAboutUs;